export class LegalEntityClassificationModel {
    questionnaireIds: Array<string> = [];
    systemId?: string = undefined;
    processingActivityId?: string = undefined;

    constructor(processingActivityId?: string) {
        this.processingActivityId = processingActivityId;
    }
}
